import { render, staticRenderFns } from "./SessionDetailModal.vue?vue&type=template&id=0445d338"
import script from "./SessionDetailModal.vue?vue&type=script&lang=js"
export * from "./SessionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./SessionDetailModal.vue?vue&type=style&index=0&id=0445d338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports